(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-regular"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      if (this.header) {
        this.createObserver();
      }
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;

      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header || !this.headerBounds) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Functionality for the new dropdown menu
  document.addEventListener('DOMContentLoaded', function () {
    // Handlers for dropdown buttons
    const toggleButtons = document.querySelectorAll('.dropdown-toggle');

    toggleButtons.forEach(function (button) {
      // Add SVG to dropdown toggles if not already present
      if (!button.querySelector('svg')) {
        button.innerHTML = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
          <g>
            <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
              c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
              c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"></path>
          </g>
        </svg>`;
      }

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Get the dropdown container
        const container = this.nextElementSibling;
        if (!container) return;

        // Toggle active class
        const wasActive = container.classList.contains('active');

        // First close all open menus
        document.querySelectorAll('.dropdown-container.active').forEach(function (openMenu) {
          openMenu.classList.remove('active');
          const toggle = openMenu.previousElementSibling;
          if (toggle && toggle.classList.contains('dropdown-toggle')) {
            toggle.setAttribute('aria-expanded', 'false');
          }
        });

        // If it was open, we already closed it above. If not, open it.
        if (!wasActive) {
          container.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Close menus when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.menu-with-dropdown')) {
        document.querySelectorAll('.dropdown-container.active').forEach(function (menu) {
          menu.classList.remove('active');
          const toggle = menu.previousElementSibling;
          if (toggle && toggle.classList.contains('dropdown-toggle')) {
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });

    // Hover functionality for desktop
    if (window.innerWidth >= 990) {
      const menuItems = document.querySelectorAll('.menu-with-dropdown');

      menuItems.forEach(function (menu) {
        menu.addEventListener('mouseenter', function () {
          const container = this.querySelector('.dropdown-container');
          const toggle = this.querySelector('.dropdown-toggle');

          if (container && toggle) {
            container.classList.add('active');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });

        menu.addEventListener('mouseleave', function () {
          const container = this.querySelector('.dropdown-container');
          const toggle = this.querySelector('.dropdown-toggle');

          if (container && toggle) {
            container.classList.remove('active');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Fix for first-level links in the main menu
    // Allow menu items with submenus to also work as links

    // For dropdown menu
    const dropdownParentItems = document.querySelectorAll('.header-dropdown-menu .has-megamenu');
    if (dropdownParentItems) {
      dropdownParentItems.forEach((item) => {
        const link = item.querySelector('summary');
        const url = link && link.dataset.href;

        if (link && url) {
          // Add a handler for click on the toggle button
          item.addEventListener('click', function (e) {
            // If the click was directly on the summary/toggle, allow the menu to open
            if (e.target === link || link.contains(e.target)) {
              // Do nothing, allow default behavior of details/summary
            } else {
              // If the click was elsewhere on the element, go to the link
              window.location.href = url;
            }
          });

          // Also add a direct click on the summary element
          link.addEventListener('click', function (e) {
            // Add a double click or long click to navigate
            if (link.dataset.clicked) {
              window.location.href = url;
              e.preventDefault();
            }

            link.dataset.clicked = true;
            setTimeout(() => {
              link.dataset.clicked = '';
            }, 300);
          });
        }
      });
    }

    // For mega menu
    const megaMenuParentItems = document.querySelectorAll('.header-mega-menu .has-megamenu');
    if (megaMenuParentItems) {
      megaMenuParentItems.forEach((item) => {
        const link = item.querySelector('summary');
        const url = link && link.dataset.href;

        if (link && url) {
          // Handle navigation to the main link
          item.addEventListener('click', function (e) {
            if (e.target === link || link.contains(e.target)) {
              // Do nothing for click on the toggle
            } else {
              window.location.href = url;
            }
          });

          // Double click on summary to navigate
          link.addEventListener('click', function (e) {
            if (link.dataset.clicked) {
              window.location.href = url;
              e.preventDefault();
            }

            link.dataset.clicked = true;
            setTimeout(() => {
              link.dataset.clicked = '';
            }, 300);
          });
        }
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Function to set mobile drawer position based on header height
    function setMobileDrawerPosition() {
      const mobileHeader = document.querySelector('.mobile-header');
      if (mobileHeader) {
        const headerHeight = mobileHeader.offsetHeight;
        document.documentElement.style.setProperty('--mobile-header-height', headerHeight + 'px');
      }
    }

    // Set initial position
    setMobileDrawerPosition();

    // Update position on window resize
    window.addEventListener('resize', setMobileDrawerPosition);

    // Mobile menu functionality
    const hamburger = document.querySelector('.mobile-hamburger');
    const closeBtn = document.querySelector('.mobile-drawer-close');
    const drawer = document.querySelector('.mobile-drawer');

    // Función para cerrar el drawer
    function closeDrawer() {
      if (drawer) {
        drawer.classList.remove('active');
        document.body.classList.remove('drawer-open');
      }
    }

    // Función para abrir el drawer
    function openDrawer() {
      if (drawer) {
        // Update position before opening to ensure it's correctly positioned
        setMobileDrawerPosition();
        drawer.classList.add('active');
        document.body.classList.add('drawer-open');
      }
    }

    // Toggle del drawer al hacer clic en el hamburguesa
    if (hamburger && drawer) {
      hamburger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (drawer.classList.contains('active')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    // Cerrar al hacer clic en el botón de cerrar
    if (closeBtn && drawer) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeDrawer();
      });
    }

    // Cerrar al hacer clic fuera del drawer
    document.addEventListener('click', function (e) {
      if (drawer && drawer.classList.contains('active')) {
        // Verificar si el clic fue fuera del drawer y del botón hamburguesa
        if (!drawer.contains(e.target) && !hamburger.contains(e.target)) {
          closeDrawer();
        }
      }
    });

    // Modified: Mobile menu toggles - Any click on the item toggles the submenu
    const toggleItems = document.querySelectorAll('.mobile-menu-item-toggle');

    toggleItems.forEach((toggleItem) => {
      // Add SVG to mobile toggles if not already present
      const toggle = toggleItem.querySelector('.mobile-toggle');
      if (toggle && !toggle.querySelector('svg')) {
        toggle.innerHTML = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
          <g>
            <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
              c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
              c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"></path>
          </g>
        </svg>`;
      }

      toggleItem.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parent = this.closest('.mobile-menu-item');
        const submenu = parent.querySelector('.mobile-submenu');
        const toggle = this.querySelector('.mobile-toggle');

        if (submenu) {
          // Toggle the submenu
          toggle.classList.toggle('active');
          submenu.classList.toggle('active');
        }
      });
    });

    // Close all menus when clicking a direct link
    const menuLinks = drawer.querySelectorAll('a');
    menuLinks.forEach((link) => {
      link.addEventListener('click', function () {
        closeDrawer();
      });
    });

    // Secondary menu dropdown functionality
    const secondaryMenuDropdowns = document.querySelectorAll('.header__secondary-menu .menu-with-dropdown');

    secondaryMenuDropdowns.forEach(function (dropdown) {
      const toggleButton = dropdown.querySelector('.dropdown-toggle');
      const container = dropdown.querySelector('.dropdown-container');

      if (toggleButton && container) {
        // Click handler for toggle buttons
        toggleButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Close all other open dropdowns first
          document.querySelectorAll('.header__secondary-menu .dropdown-container.active').forEach(function (openMenu) {
            if (openMenu !== container) {
              openMenu.classList.remove('active');
              const toggle = openMenu.previousElementSibling;
              if (toggle && toggle.classList.contains('dropdown-toggle')) {
                toggle.setAttribute('aria-expanded', 'false');
              }
            }
          });

          // Toggle current dropdown
          const isActive = container.classList.contains('active');
          container.classList.toggle('active');
          toggleButton.setAttribute('aria-expanded', !isActive);
        });

        // Hover functionality for desktop
        if (window.innerWidth >= 990) {
          dropdown.addEventListener('mouseenter', function () {
            container.classList.add('active');
            toggleButton.setAttribute('aria-expanded', 'true');
          });

          dropdown.addEventListener('mouseleave', function () {
            container.classList.remove('active');
            toggleButton.setAttribute('aria-expanded', 'false');
          });
        }
      }
    });

    // Close secondary dropdowns when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header__secondary-menu .menu-with-dropdown')) {
        document.querySelectorAll('.header__secondary-menu .dropdown-container.active').forEach(function (menu) {
          menu.classList.remove('active');
          const toggle = menu.previousElementSibling;
          if (toggle && toggle.classList.contains('dropdown-toggle')) {
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
